import React from "react";
import DateTHead from "./DateTHead";
import DateTBody from "./DateTBody";

export default class DateTable extends React.Component {
  render() {
    const props = this.props;
    const prefixCls = props.prefixCls;
    return (
      <table className={`${prefixCls}-table`} cellSpacing="0" role="grid">
        <DateTHead {...props} ecId={`${props.ecId}_DateTHead@n7u0ha`} />
        <DateTBody {...props} ecId={`${props.ecId}_DateTBody@zdisx6`} />
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/date/DateTable.jsx